import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'show_ai_highlights';
const EVENT_NAME = 'ai-highlight-preference-changed';

const readPreference = (): boolean => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
};

export const useAIHighlightPreference = (): [boolean, (value: boolean) => void] => {
  const [showHighlights, setShowHighlights] = useState<boolean>(readPreference);

  useEffect(() => {
    const handler = () => setShowHighlights(readPreference());
    window.addEventListener(EVENT_NAME, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(EVENT_NAME, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  const setPreference = useCallback((value: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {}
    setShowHighlights(value);
    window.dispatchEvent(new Event(EVENT_NAME));
  }, []);

  return [showHighlights, setPreference];
};
